function DashboardAdm() {
    return (
        <h1>Teste dashboard</h1>
    )
}

export default DashboardAdm